module.exports = __webpack_public_path__ + "img/1684205717991-image.jpg.ca4fcbdc.webp";